export default "__VITE_ASSET__Cjr450ks__"